import { h } from 'preact';
import PureComponent from './PureComponent';
import PartyPill from './PartyPill';
import { getLocalRaceTitle } from '../utils/branch-ballot';

const PARTY_NAMES = {
  D: 'Democrat',
  R: 'Republican',
  L: 'Libertarian',
  G: 'Green',
  I: 'Independent',
  N: 'Nonpartisan',
};

const partyName = party => PARTY_NAMES[party] || party;

// How many local races and measures show before the "See more" button is clicked.
const INITIAL_VISIBLE_RACES = 4;

class LocalCandidate extends PureComponent {
  render() {
    const { candidate } = this.props;

    return (
      <tr class="candidate race__candidate-row">
        <td class="candidate__cell candidate__party">
          {candidate.party && <PartyPill party={partyName(candidate.party)} />}
        </td>
        <th class="candidate__cell candidate__name">{candidate.name}</th>
      </tr>
    );
  }
}

class LocalRace extends PureComponent {
  render() {
    const { race } = this.props;
    const candidates = race.candidates || [];

    return (
      <div class="seat">
        <h3 class="seat__title">
          <span>{getLocalRaceTitle(race)}</span>
        </h3>
        {candidates.length > 0 ? (
          <table class="race__candidates">
            <thead>
              <tr>
                <th class="contest__candidate-header" colSpan={2}>
                  Candidates
                </th>
              </tr>
            </thead>
            <tbody>
              {candidates.map(candidate => (
                <LocalCandidate key={candidate._id} candidate={candidate} />
              ))}
            </tbody>
          </table>
        ) : (
          <div class="no_primary_candidates">No candidates listed yet.</div>
        )}
      </div>
    );
  }
}

class LocalMeasure extends PureComponent {
  render() {
    const { measure } = this.props;

    return (
      <div class="seat">
        <h3 class="seat__title">
          <span>{measure.title}</span>
        </h3>
        {measure.ballotText && (
          <p class="local-measure__text">{measure.ballotText}</p>
        )}
      </div>
    );
  }
}

class LocalRaces extends PureComponent {
  constructor() {
    super();

    this.state = { expanded: false };
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  // Collapse again when a new lookup replaces the races (resetKey changes),
  // so the next address doesn't inherit the previous one's expanded state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.resetKey !== this.props.resetKey) {
      this.setState({ expanded: false });
    }
  }

  toggleExpanded() {
    const { expanded } = this.state;

    if (!expanded) {
      this.setState({ expanded: true });
      return;
    }

    this.setState({ expanded: false }, () => {
      if (!this.section) return;

      // The button floats, so the reader can click it from anywhere in the
      // long list — and most of what they were looking at disappears. If the
      // top of the section is now above the screen, land on it right away
      // rather than scrolling back up past rows that no longer exist.
      if (this.section.getBoundingClientRect().top < 0) {
        this.section.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    });
  }

  render() {
    const { races = [], measures = [] } = this.props;
    const { expanded } = this.state;

    if (races.length === 0 && measures.length === 0) {
      return (
        <div class="local-races-section">
          <p class="has-padding t-serif">
            Local race information isn't fully available for your address yet.
          </p>
        </div>
      );
    }

    // Measures go in the same grid (and behind the same "See all") as the
    // races, so the local section reads as one list.
    const items = [
      ...races.map(race => <LocalRace key={race._id} race={race} />),
      ...measures.map(measure => (
        <LocalMeasure key={measure._id} measure={measure} />
      )),
    ];

    return (
      <div class="local-races-section" ref={el => (this.section = el)}>
        <div class="local-races">
          {expanded ? items : items.slice(0, INITIAL_VISIBLE_RACES)}
        </div>
        {items.length > INITIAL_VISIBLE_RACES && (
          <button
            type="button"
            class={
              expanded
                ? 'local-races-section__more local-races-section__more--floating'
                : 'local-races-section__more'
            }
            onClick={this.toggleExpanded}
          >
            {expanded
              ? 'See less'
              : `See all (+${items.length - INITIAL_VISIBLE_RACES})`}
          </button>
        )}
      </div>
    );
  }
}

export default LocalRaces;
